<div class="au">
  <div class="au__card">

    <span class="au__icon" aria-hidden="true">
      <i class="fa-solid fa-link-slash"></i>
    </span>

    <h1 class="au__title">{{ 'ACCOUNT_UNLINKED.TITLE' | translate }}</h1>

    <p class="au__lead">
      {{ 'ACCOUNT_UNLINKED.LEAD' | translate: { role: roleLabelKey | translate } }}
    </p>

    <!-- Ce que l'établissement doit connaître pour créer la fiche. -->
    <dl class="au__facts">
      <div class="au__fact">
        <dt>{{ 'ACCOUNT_UNLINKED.EMAIL' | translate }}</dt>
        <dd>
          <code>{{ email() || '—' }}</code>
          <button type="button" class="au__copy" (click)="copyEmail()"
                  [attr.aria-label]="'ACCOUNT_UNLINKED.COPY' | translate">
            <i class="fa-solid" [ngClass]="copied() ? 'fa-check' : 'fa-copy'"></i>
            {{ (copied() ? 'ACCOUNT_UNLINKED.COPIED' : 'ACCOUNT_UNLINKED.COPY') | translate }}
          </button>
        </dd>
      </div>
      <div class="au__fact">
        <dt>{{ 'ACCOUNT_UNLINKED.USER_ID' | translate }}</dt>
        <dd><code class="au__id">{{ userId() || '—' }}</code></dd>
      </div>
    </dl>

    <p class="au__hint">{{ 'ACCOUNT_UNLINKED.HINT' | translate }}</p>

    <div class="au__actions">
      <button type="button" class="au__btn au__btn--primary" (click)="retry()">
        <i class="fa-solid fa-rotate-right"></i>
        {{ 'ACCOUNT_UNLINKED.RETRY' | translate }}
      </button>
      <button type="button" class="au__btn" (click)="logout()">
        <i class="fa-solid fa-arrow-right-from-bracket"></i>
        {{ 'ACCOUNT_UNLINKED.LOGOUT' | translate }}
      </button>
    </div>

  </div>
</div>
